import { useEffect } from 'react';
import { useLocation } from 'react-router-dom';

const GoogleAnalytics = () => {
  const location = useLocation();

  useEffect(() => {
    // Track page view when location changes
    if (window.gtag) {
      window.gtag('config', 'G-N2Y9N08QD7', {
        page_path: location.pathname + location.search
      });
    }
  }, [location]);

  // Track custom events
  const trackEvent = (action, category, label, value) => {
    if (window.gtag) {
      window.gtag('event', action, {
        event_category: category,
        event_label: label,
        value: value
      });
    }
  };

  // Track user registration
  const trackRegistration = (method = 'email') => {
    trackEvent('sign_up', 'engagement', method);
  };

  // Track login
  const trackLogin = (method = 'email') => {
    trackEvent('login', 'engagement', method);
  };

  // Track skin analysis
  const trackSkinAnalysis = () => {
    trackEvent('skin_analysis', 'feature_usage', 'analysis_completed');
  };

  // Track routine creation
  const trackRoutineCreation = () => {
    trackEvent('routine_creation', 'feature_usage', 'routine_created');
  };

  // Track product analysis
  const trackProductAnalysis = () => {
    trackEvent('product_analysis', 'feature_usage', 'product_analyzed');
  };

  // Track onboarding completion
  const trackOnboardingCompletion = () => {
    trackEvent('onboarding_completion', 'engagement', 'profile_completed');
  };

  // Expose tracking functions globally
  useEffect(() => {
    window.trackEvent = trackEvent;
    window.trackRegistration = trackRegistration;
    window.trackLogin = trackLogin;
    window.trackSkinAnalysis = trackSkinAnalysis;
    window.trackRoutineCreation = trackRoutineCreation;
    window.trackProductAnalysis = trackProductAnalysis;
    window.trackOnboardingCompletion = trackOnboardingCompletion;
  }, []);

  return null; // This component doesn't render anything
};

export default GoogleAnalytics;






